import {HelpersService} from '../../core/helpers/helpers.service';
import {Injectable} from '@angular/core';

@Injectable()
export abstract class BaseDataService {

  constructor(protected helpers: HelpersService) {

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/commons/base-data.service.ts